module.exports = __webpack_public_path__ + "static/media/kpihicon.69c7ed49.png";